import React from 'react';
import type { AppProps } from 'next/app';
import ReactDOM from 'react-dom';

export default function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}
